import {
  PaymentCondition,
  PaymentMethodValues,
  TransactionTypesChoices,
} from './helpers';

export function resolvePaymentCondition(
  transactionType?: TransactionTypesChoices,
  paymentType?: PaymentMethodValues,
): PaymentCondition {
  if (!transactionType || !paymentType) {
    return PaymentCondition.INVALID;
  }

  const isCashPayment = paymentType === PaymentMethodValues.CASH_PAYMENT;

  const isCreditPayment = [
    PaymentMethodValues.CREDIT_PAYMENT,
    PaymentMethodValues.CASH_CREDIT_PAYMENT,
    PaymentMethodValues.CASHBACK_PAYMENT,
    PaymentMethodValues.CASHBACK_CASH_PAYMENT,
  ].includes(paymentType);

  switch (transactionType) {
    case TransactionTypesChoices.ORDER:
      if (isCashPayment) return PaymentCondition.ORDER_CASH;
      if (isCreditPayment) return PaymentCondition.ORDER_CREDIT;
      break;

    case TransactionTypesChoices.STORE_ORDER:
      if (isCashPayment) return PaymentCondition.STORE_ORDER_CASH;
      if (isCreditPayment) return PaymentCondition.STORE_ORDER_CREDIT;
      break;
  }

  return PaymentCondition.INVALID;
}
